// Desc: Admin Overview page
import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
// import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button";
import { useState } from "react";
// import { ToastContainer } from "react-toastify";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import SentInvoice from "../admin/component/SentInvoice";
import SavedInvoices from "../admin/component/SavedInvoice";
import AllInvoices from "../admin/component/AllInvoices";
import { useNavigate } from "react-router-dom";

const InvoicePage = () => {
  const [value, setValue] = useState("all-invoice");
  const navigate = useNavigate();
  //   const navigate = useNavigate();

  /**
 * Handles tab change events and updates the current tab value
 * @param {React.SyntheticEvent} event - The event triggered by tab change
 * @param {number|string} newValue - The value of the newly selected tab
 */
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Layout children={
      <>
        <PageTitle
          title="All Invoices"
          subtitle="View all invoice created."
          button={
            <div className="flex gap-10">
              <div className="flex gap-10">
                <Button onClick={() => navigate("/payment/create-invoice")} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Create Invoice" />
              </div>
            </div>
          }
        />
        <div>
          <TabContext value={value}>
            <div className="tablist-container padding-left-16">
              <Tabs
                className="overide-tablist"
                onChange={handleTabChange}
                aria-label="lab API tabs example"
              >
                <Tab label="All Invoices" value="all-invoice" />
                <Tab label="Sent Invoice" value="sent-invoice" />
                <Tab label="Saved Invoice" value="saved-invoice" />
              </Tabs>
            </div>
            <>
              {/* <CardSearch placeholder="Search here ..." onChange={handleLibrarySearch} /> */}
              <TabPanel value="all-invoice" className="tabpanel-overide">
                <AllInvoices />
              </TabPanel>
              <TabPanel value="sent-invoice" className="tabpanel-overide">
                <SentInvoice />
              </TabPanel>
              <TabPanel value="saved-invoice" className="tabpanel-overide">
                <SavedInvoices />
              </TabPanel>
            </>
          </TabContext>
        </div>
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default InvoicePage;
